import React, { useEffect } from "react";
import MobileMenuSearch from "./sub-components/MobileSearch";
import MobileNavMenu from "./sub-components/MobileNavMenu";
import MobileLangCurChange from "./sub-components/MobileLangCurrChange";
import MobileWidgets from "./sub-components/MobileWidgets";
import { CloseModalSvg, MenuArrowDownSvg } from "../../assets/svgs/svgs";
import { useScrollLock } from "../../hooks/useScrollLock";
import Logo from "./Logo";
import { useAppSelector } from "../../hooks/useReduxMethods";
import CrossSvg from "../../assets/svgs/CrossSvg";

const MobileMenu = () => {
  const { lockScroll, unlockScroll } = useScrollLock();
  const { bussinessData } = useAppSelector((state) => state.bussinessData);
  useEffect(() => {
    const offCanvasNav = document.querySelector("#offcanvas-navigation");
    const offCanvasNavSubMenu = offCanvasNav.querySelectorAll(".sub-menu");
    const anchorLinks = offCanvasNav.querySelectorAll("a");

    for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
      offCanvasNavSubMenu[i].insertAdjacentHTML(
        "beforebegin",
        `<span class='menu-expand'><i></i></span>`
      );
    }

    const menuExpand = offCanvasNav.querySelectorAll(".menu-expand");
    const numMenuExpand = menuExpand.length;

    for (let i = 0; i < numMenuExpand; i++) {
      menuExpand[i].addEventListener("click", (e) => {
        sideMenuExpand(e);
      });
    }

    for (let i = 0; i < anchorLinks.length; i++) {
      anchorLinks[i].addEventListener("click", () => {
        closeMobileMenu();
      });
    }
  });

  const sideMenuExpand = (e) => {
    e.currentTarget.parentElement.classList.toggle("active");
  };

  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.remove("active");
    const announcementBar = document.querySelector(".announcement-bar");
    if (announcementBar) {
      announcementBar.style.display = "flex";
    }
    unlockScroll();
  };
  useEffect(() => {
    console.log(bussinessData?.site_settings?.siteLogo);
  }, [bussinessData]);
  return (
    <div className="offcanvas-mobile-menu" id="offcanvas-mobile-menu">
      <button
        className="offcanvas-menu-close "
        id="mobile-menu-close-trigger"
        onClick={() => closeMobileMenu()}
      >
        x{/* <div className="marquee-close-btn">x</div> */}
        {/* <i className="pe-7s-close"></i> */}
      </button>

      <div className="offcanvas-wrapper">
        <div className="offcanvas-inner-content">
          {/* mobile search */}
          <MobileMenuSearch />

          <Logo
            imageUrl={bussinessData?.site_settings?.siteLogo}
            // imageUrl={"https://dev.taiftec.com/sites/watniya/img/logo.png"}
            // imageUrl="/assets/img/logo/logo.png"
            logoClass="logo-hm-9 pl-20 pr-20"
          />
          {/* mobile nav menu */}
          <MobileNavMenu />

          {/* mobile language and currency */}
          <MobileLangCurChange />

          {/* mobile widgets */}
          <MobileWidgets />
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
